import React from 'react'

export const ListAndDetailSamplesPaginationPageInfo = () => {
  return (
    <>
        The list has pagination built in.<br />
        It defaults to 50 but you change it by using the pageSize prop.<br />
        <br />
        This example only shows the pagination and isn't concerned about showing how deleting and navigating to a detail page works.
        See the other examples to see how these work.
    </>
  )
}
